module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.modal.show) ? _c('div', {
    staticClass: "modal-transition modal-mask notification",
    on: {
      "click": _vm.hideModal
    }
  }, [_c('div', {
    staticClass: "modal-confirm",
    on: {
      "click": _vm.prevent
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n                        默认内容 可通过slot分发自定义\n                    ")])], 2)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55868aee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medianav/portal/modal.vue
// module id = 445
// module chunks = 2